import { showToast } from '../config_and_helpers/helpers';

/**
 * User-facing messages for S3 upload finalize failures (400 when object missing on backend).
 */

/**
 * @param {Object|Array|string|null} errPayload - DRF error body or axios message
 * @returns {string[]}
 */
export function formatUploadFinalizeErrors(errPayload) {
  if (errPayload == null) {
    return [
      'Upload could not be confirmed. The file may not have reached storage. Try uploading again.',
    ];
  }
  if (typeof errPayload === 'string') {
    return [errPayload];
  }
  if (Array.isArray(errPayload)) {
    return errPayload.map(v => String(v));
  }

  const messages = [];
  if (Array.isArray(errPayload.non_field_errors)) {
    messages.push(...errPayload.non_field_errors.map(v => String(v)));
  }
  Object.keys(errPayload).forEach(key => {
    if (key === 'non_field_errors') return;
    const val = errPayload[key];
    if (Array.isArray(val)) {
      val.forEach(v => messages.push(String(v)));
    } else if (typeof val === 'string') {
      messages.push(val);
    }
  });

  if (messages.length === 0) {
    return [
      'Upload could not be confirmed. The file may not have reached storage. Try uploading again.',
    ];
  }
  return messages;
}

/**
 * @param {Object|Array|string|null} errPayload
 * @returns {string}
 */
export function uploadFinalizeErrorMessage(errPayload) {
  const list = formatUploadFinalizeErrors(errPayload);
  return list[0] || list.join(' ');
}

/**
 * Show a toast for a failed S3 upload finalize (400 when object missing on backend).
 *
 * @param {string[]|Object|Array|string|null} messagesOrPayload
 */
export function notifyUploadFinalizeFailure(messagesOrPayload) {
  const text = Array.isArray(messagesOrPayload) && messagesOrPayload.length
    ? messagesOrPayload[0]
    : uploadFinalizeErrorMessage(messagesOrPayload);
  showToast(text, 'error', 'top-right', 5000);
}
